
export const types ={
    selectBriefcase : "SELECT_BRIEFCASE"
}


export const selectBriefcase =  (briefcase) =>{
    return{
        type:types.selectBriefcase,
        briefcase
    }
}

